import { Divider as MuiDivider, Stack, Typography } from '@mui/material'

/**
 * Divisor — envoltorio delgado sobre `Divider` de MUI (ya con el color de
 * borde correcto vía theme/components.ts). Nombrado `LabeledDivider` en
 * vez de `Divider` para no chocar con el import de MUI; cubre además el
 * caso con etiqueta ("EVIDENCIA", "TEMAS") que MUI no da por defecto.
 */
export function LabeledDivider({ label }: { label?: string }) {
  if (!label) return <MuiDivider />
  return (
    <Stack direction="row" alignItems="center" spacing={1.5}>
      <MuiDivider sx={{ flex: 1 }} />
      <Typography variant="caption" color="text.disabled" sx={{ letterSpacing: '0.06em' }}>
        {label.toUpperCase()}
      </Typography>
      <MuiDivider sx={{ flex: 1 }} />
    </Stack>
  )
}
